import { useMutation, useQueryClient } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { TRemoveFromTeamBody } from "./types";
import { translations } from "../../../i18n/translations";
import { Queries } from "../../../constants/queries";
import { deleteRemoveFromTeam } from "./deleteRemoveFromTeam";

export const useRemoveFromTeam = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation<unknown, unknown, Partial<TRemoveFromTeamBody>>(
    (payload) => deleteRemoveFromTeam(payload),
    {
      onError: () => {
        toast({
          title: "Error",
          description: t<string>(translations.errors.remove_from_team_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(Queries.Team(variables.companyId));
        queryClient.invalidateQueries(Queries.UserById(variables.userId));
      },
    }
  );
};
